import React from "react";

import { useTranslation } from "react-i18next";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/src/components/ui/dialog";
import { Textarea } from "@/src/components/ui/textarea";

import type { JSX } from "react";

interface FreecopyCodeLinkDialogProps {
  link: string | null;
  onClose: () => void;
}

function FreecopyCodeLinkDialog({
  link,
  onClose,
}: FreecopyCodeLinkDialogProps): JSX.Element {
  const { t } = useTranslation("editor-freecopy");

  const handleOpenChange = (isOpen: boolean): void => {
    if (!isOpen) onClose();
  };

  return (
    <Dialog onOpenChange={handleOpenChange} open={link !== null}>
      <DialogContent aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>{t("codeLink")}</DialogTitle>
        </DialogHeader>
        <Textarea readOnly rows={4} value={link ?? ""} />
      </DialogContent>
    </Dialog>
  );
}

export default FreecopyCodeLinkDialog;
